(window as any).global = window;
import '@angular/common/locales/global/en';
import '@angular/common/locales/global/it';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app.component';
import { appConfig } from './app.config';
import { EnvironmentService } from './app/@core/services/environment.service';

let envService = new EnvironmentService();

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));


// Configure Amplify
// Amplify.configure({
//   Auth: {
//     Cognito: {
//       userPoolId: envService.oauthCognitoUserPoolId,
//       userPoolClientId: envService.oauthCognitoClientId,
//     }
//   }
// });
